import { render, staticRenderFns } from "./smtFileView.vue?vue&type=template&id=039866ca&scoped=true"
import script from "./smtFileView.vue?vue&type=script&lang=js"
export * from "./smtFileView.vue?vue&type=script&lang=js"
import style0 from "./smtFileView.vue?vue&type=style&index=0&id=039866ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039866ca",
  null
  
)

export default component.exports